import Cookies from 'universal-cookie';

let cookies;

function initCookies() {
	if(cookies === undefined) {
		cookies = new Cookies();
	}
}

function getCookie(key) {
	initCookies();
	return cookies.get(key) || false;
}

function setCookie(key, value) {
	initCookies();
	cookies.set(key, value, { path: '/', expires: new Date(Date.UTC(2023, 0, 0, 0, 0, 0)), sameSite: "lax" });
}

function removeCookie(key) {
	initCookies();
	cookies.remove(key, { path: '/' });
}

export function acceptCookies() {
	setCookie('cookiesAccepted', +new Date());
}

export function getAcceptStatus() {
	return getCookie('cookiesAccepted');
}

export function setAuth(auth) {
	setCookie('auth', auth);
}

export function getAuth() {
	return getCookie('auth');
}

export function clearAuth() {
	removeCookie('auth');
}

export function setReferrer(referrer) {
	setCookie('referrer', referrer);
}

export function getReferrer() {
	return getCookie('referrer');
}


// WEBPACK FOOTER //
// /opt/build/repo/src/utils/CookiesHelper.js